/*
 * NextGenn engine · the bag helper.
 *
 * One way into the bag for every `ngs-` section, so the shelf, the ritual and
 * whatever comes next all behave the way Dawn's own Add to cart does: the
 * drawer slides open with the new lines in it and the header count moves,
 * without a page load. It copies what assets/product-form.js does after a
 * successful add, because that is the behaviour the rest of the theme expects.
 *
 *   NGSCart.add([{ id: variantId, quantity: 1 }, …])  →  Promise
 *
 * Several lines go in ONE request, so a five-bottle ritual is either in the
 * bag or not: five separate requests can half-succeed, and a ritual with two
 * bottles missing is worse than an error. Anything else on a line (a
 * `properties` object, a `selling_plan`) is passed through untouched.
 *
 * On a refusal the promise rejects with the sentence Shopify wrote ("All 2
 * The Serum are in your cart."), and the error carries `response`, so a caller
 * can tell Shopify's own words from a dropped connection and only print the
 * first.
 *
 * It also defines <ngs-add>, a wrapper for a plain product form: without this
 * file the form still posts and lands on the cart page, with it the same
 * button opens the drawer. Sections load this file more than once on a page,
 * hence the guards.
 */
(function () {
  if (window.NGSCart) return;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function cartPage() {
    return (window.routes && window.routes.cart_url) || root() + 'cart';
  }

  function refusal(data) {
    var words = typeof data.description === 'string' ? data.description : data.message;
    var error = new Error(typeof words === 'string' && words ? words : 'Cart error');
    error.name = 'NGSCartError';
    error.response = data;
    return error;
  }

  function add(items) {
    var lines = (Array.isArray(items) ? items : [items])
      .filter(function (item) {
        return item && item.id;
      })
      .map(function (item) {
        return Object.assign({}, item, {
          id: Number(item.id) || item.id,
          quantity: Math.max(1, parseInt(item.quantity, 10) || 1),
        });
      });
    if (!lines.length) return Promise.reject(new Error('Nothing to add'));

    var drawer = document.querySelector('cart-drawer');
    /* The element the drawer hands focus back to when it closes. */
    if (drawer && typeof drawer.setActiveElement === 'function') drawer.setActiveElement(document.activeElement);

    return fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        items: lines,
        /* Dawn's drawer and the header bubble, rendered by Shopify in the same
           round trip, so there is no second request and no flash of the old count. */
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        return response
          .json()
          .catch(function () {
            return {};
          })
          .then(function (data) {
            /* Shopify answers a refusal with JSON that carries a `status`. */
            if (!response.ok || data.status) throw refusal(data);
            return data;
          });
      })
      .then(function (data) {
        var cart = document.querySelector('cart-drawer');
        /* No drawer (the theme is set to the cart page or the notification):
           the cart page is the one place that is always right. */
        if (!cart || typeof cart.renderContents !== 'function' || !data.sections) {
          window.location = cartPage();
          return data;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ngs-cart', cartData: data });
        }
        cart.renderContents(data);
        cart.classList.remove('is-empty');
        return data;
      });
  }

  window.NGSCart = { add: add };

  if (!customElements.get('ngs-add')) {
    customElements.define(
      'ngs-add',
      class NGSAdd extends HTMLElement {
        connectedCallback() {
          if (this.form) return;
          this.form = this.querySelector('form');
          if (!this.form) return;
          this.button = this.form.querySelector('[type="submit"]');
          this.status = this.querySelector('[data-ngs-status]');
          this.form.addEventListener('submit', this.onSubmit.bind(this));
          if (this.button && document.querySelector('cart-drawer')) this.button.setAttribute('aria-haspopup', 'dialog');
        }

        onSubmit(event) {
          var input = this.form.querySelector('[name="id"]');
          if (!input || !input.value) return;
          event.preventDefault();
          if (this.button.getAttribute('aria-disabled') === 'true') return;

          this.say('');
          this.button.setAttribute('aria-disabled', 'true');
          this.classList.add('is-adding');

          var quantity = this.form.querySelector('[name="quantity"]');
          add([{ id: input.value, quantity: quantity ? quantity.value : 1 }])
            .catch(
              function (error) {
                this.say(error.response ? error.message : this.dataset.error || error.message);
              }.bind(this)
            )
            .finally(
              function () {
                this.button.removeAttribute('aria-disabled');
                this.classList.remove('is-adding');
              }.bind(this)
            );
        }

        say(words) {
          if (!this.status) return;
          this.status.textContent = words;
          this.status.hidden = !words;
        }
      }
    );
  }
})();
